import TIM from "tim-js-sdk";
import tim from "../utils/tim";

export default {
  onEvn: (evn, fun) => tim.on(TIM.EVENT[evn], fun),
  offEvn: (evn, fun) => tim.off(TIM.EVENT[evn], fun),
  loginIM: (userID, userSig) => tim.login({ userID, userSig }),
  logoutIM: () => tim.logout(),
  getMsgList: (conversationID, nextReqMessageID, count) =>
    tim.getMessageList({ conversationID, nextReqMessageID, count }),

  setMessageRead: conversationID => tim.setMessageRead({ conversationID }),
  createTextMessage: (user, text) =>
    tim.createTextMessage({
      to: user,
      conversationType: TIM.TYPES.CONV_C2C,
      // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
      // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
      // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
      payload: {
        text
      }
    }),
  sendMsg: msg => tim.sendMessage(msg),
  resendMessage: msg => tim.resendMessage(msg),
  delConversation: conversationID => tim.deleteConversation(conversationID),
  getConversationProfile: conversationID =>
    tim.getConversationProfile(conversationID),
  revokeMsg: msg => tim.revokeMessage(msg),
  getConversationList: () => tim.getConversationList(),
  addToBlacklist: users => tim.addToBlacklist({ userIDList: users }),
  removeFromBlacklist: users => tim.removeFromBlacklist({ userIDList: users }),
  getBlacklist: () => tim.getBlacklist()
};
